import { render, staticRenderFns } from "./ExhibitPreview.vue?vue&type=template&id=13bdda25&scoped=true&"
import script from "./ExhibitPreview.vue?vue&type=script&lang=js&"
export * from "./ExhibitPreview.vue?vue&type=script&lang=js&"
import style0 from "./ExhibitPreview.vue?vue&type=style&index=0&id=13bdda25&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13bdda25",
  null
  
)

export default component.exports